//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { ContentType, Language } from '@constants'

const JOB = gql`
  query ($where: JobFilterInput) {
    job(where: $where) {
      id
      externalId
      title
      slug
      languageId
      language {
        locale
      }
      company
      companyLogo
      jobCategory
      startAt
      location
      abstract
      keywords
      content
    }
  }
`

export default {
  name: 'Job',
  fetchOnServer: false,
  scrollToTop: true,
  data() {
    return {
      job: null,
      showPlaceholder: true,
      ContentType,
      Language,
      loadedImg: false,
      brokenImg: false
    }
  },
  async fetch() {
    this.showPlaceholder = true

    try {
      const { data } = await this.$apollo.query({
        query: JOB,
        variables: {
          where: {
            externalId: {
              eq: this.queryId
            }
          }
        }
      })

      this.job = data.job

      if (this.job) {
        this.setBreadcrumb({
          isShow: true,
          pageCategory: this.$t('jobs.jobs'),
          categoryRedirectUrl: `/jobs`,
          pageTitle: this.job.title
        })
      }
    } catch (error) {
      this.handleError(error)
    } finally {
      this.showPlaceholder = false
    }
  },
  head() {
    const canonical =
      this.$config.baseURL +
      (this.job ? `/jobs/${this.job.slug}--${this.job.externalId}` : `/jobs/${this.titleSlug}--${this.queryId}`)

    return {
      title: this.job ? `${this.job?.title} - Telecompaper` : 'Telecompaper',
      meta: [
        { httpEequiv: 'content-language', content: this.job?.language?.locale ?? 'en' },
        { name: 'robots', content: 'noarchive' },
        { name: 'description', content: this.job?.abstract?.substring(0, 512) ?? '' },
        { name: 'og:description', content: this.job?.abstract?.substring(0, 512) ?? '' },
        { name: 'og:url', content: canonical },
        { name: 'og:title', content: this.job?.title ?? '' }
      ],
      link: [
        {
          rel: 'canonical',
          href: canonical
        }
      ]
    }
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    slugParts() {
      const slug = this.$route.params.slug.split('--')
      return slug
    },
    titleSlug() {
      return this.slugParts[0]
    },
    queryId() {
      return Number.parseInt(this.slugParts[this.slugParts.length - 1])
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  watch: {
    languageId() {
      this.$router.push({ path: '/jobs' })
    }
  }
}
